import { createApp } from "vue";
import App from "./App.vue";
import emailjs from "@emailjs/browser";

const app = createApp(App);
emailjs.init(process.env.VUE_APP_YOUR_PUBLIC_KEY);

app.mount("#app");
